import { TAdverseMediaStatus } from './types';
import { compareAsc } from 'date-fns';

type TAdverseMediaRecords = Partial<TAdverseMediaStatus>[];

/**
 * Sorts the adverse media records in ascending order by their last updated date.
 * @param data - The array of adverse media records to sort.
 * @returns The sorted array of adverse media records.
 */
export function ascOrderRecords(data: TAdverseMediaRecords): TAdverseMediaRecords {
  return data.sort((a, b) => {
    // Handle undefined dates: treat undefined as "latest" (sort last)
    if (!a.lastUpdatedDatetime && !b.lastUpdatedDatetime) return 0;
    if (!a.lastUpdatedDatetime) return 1;
    if (!b.lastUpdatedDatetime) return -1;
    return compareAsc(new Date(a.lastUpdatedDatetime), new Date(b.lastUpdatedDatetime));
  });
}

/**
 * Retrieves the latest adverse media record from the array.
 * @param data - The array of adverse media records to search.
 * @returns The latest adverse media record, or undefined if no records exist.
 */
export function latestRecord(data: TAdverseMediaRecords): Partial<TAdverseMediaStatus> | undefined {
  const sortedRecords = ascOrderRecords(data);
  return sortedRecords.at(-1);
}
